/**
 * The wordmark, in two theme colours rather than a palette of its own.
 *
 * @module components/shared/BrandWordmark
 */

import { barRadius, bars, barWidth, markViewBox } from "@/brand/mark";
import { GlyphScale, type WordmarkSize } from "@/components/ui";

interface BrandWordmarkProps {
  className?: string;
  /** A glyph size from the type scale, or `wordmark` for the brand mark's own. */
  size?: WordmarkSize;
  /** The mark beside the words. Off where the wordmark sits inside a card. */
  mark?: boolean;
}

export function BrandWordmark({
  className = "",
  size = undefined,
  mark = true,
}: BrandWordmarkProps) {
  // No `aria-label`: the spans below already read "SocratIQ", and it is
  // prohibited on a `div` with no role. The mark is `aria-hidden`, so the
  // words are the name.
  return (
    <GlyphScale size={size} className={`flex items-center gap-3 ${className}`.trim()}>
      {mark && (
        // Theme tokens, not fixed colours, so the bars invert with the canvas.
        <svg
          className="h-7 w-auto shrink-0 fill-current text-base-content"
          viewBox={`0 0 ${markViewBox.width} ${markViewBox.height}`}
          aria-hidden="true"
        >
          {bars.map((bar) => (
            <rect
              key={bar.x}
              x={bar.x}
              y={bar.y}
              width={barWidth}
              height={bar.height}
              rx={barRadius}
              className={bar.accent ? "fill-brand-mark" : undefined}
            />
          ))}
        </svg>
      )}
      <span className="text-base-content" translate="no">
        <span className="font-medium">Socrat</span>
        <span className="font-bold">IQ</span>
      </span>
    </GlyphScale>
  );
}
